<template>
    <AdminNextIframe
        path="/markets/"
        :query="{ clientId: $route.params.id }" />
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'ClientMarketsManager',
    components: { AdminNextIframe }
}
</script>
